import axios from "axios";

const api = axios.create({
    baseURL: "https://api.kidssey.com",
    timeout: 3000,
    headers: { Authorization: `Bearer ${process.env.REACT_APP_API_KEY}` },
});

export default api;
